'use strict';

import Comment from '../api/comment';

import delegateListener from './delegate-listener';
import { triggerEvent } from './dom-helpers';

class CommentsHelper {
  constructor(options) {
    const defaults = {
      commentSelector: '[data-comment-id]',
      importantSelector: '[data-comment-toggle-important]',
      seenSelector: '[data-comment-mark-seen]',
      deleteSelector: '[data-comment-delete]',
      containerSelector: '#item__comments,[data-modal="comments-modal"],body.page--main-listing',
      confirmRemoveCommentMessage: 'Tahdotko varmasti poistaa tämän kommentin?'
    }

    Object.assign(this, defaults, options);
  }

  init(){
    const containers = document.querySelectorAll(this.containerSelector);
    if(containers.length === 0) return;

    this.boundSeenClick = this._handleSeenClick.bind(this);
    this.boundImportantClick = this._handleImportantClick.bind(this);
    this.boundDeleteClick = this._handleDeleteClick.bind(this);

    // Eh.. Maybe we should just bind to document.body?
    containers.forEach(container => {
      container.addEventListener('click', delegateListener(this.seenSelector, this.boundSeenClick));
      container.addEventListener('click', delegateListener(this.importantSelector, this.boundImportantClick));
      container.addEventListener('click', delegateListener(this.deleteSelector, this.boundDeleteClick));
    }, this);
  }

  _findCommentElements(commentId) {
    let comments = document.querySelectorAll(`[data-comment-id="${ commentId }"]`);
    if(comments.length > 0) return comments;
    return [];
  }

  isCommentImportant(commentId) {
    let comment = this._findCommentElements(commentId);
    return comment[0].classList.contains('quote-box--important');
  }

  _handleImportantClick(event) {
    let commentId = parseInt(event.delegateTarget.dataset.commentToggleImportant, 10);

    if(this.isCommentImportant(commentId)) {
      this.demote(commentId).then(res => {
        if(res.status === 'OK') {
          this.demoteComment(commentId);
        }
      });
    } else {
      this.elevate(commentId).then(res => {
        if(res.status === 'OK') {
          this.elevateComment(commentId);
        }
      });
    }
  }

  _handleSeenClick(event) {
    let commentId = parseInt(event.delegateTarget.dataset.commentMarkSeen, 10);
    this.see(commentId).then(res => {
      this.seeComment(commentId);
    });
  }

  see(commentId) {
    return new Comment(commentId).see();
  }

  seeComment(commentId) {
    this._findCommentElements(commentId).forEach(comment => {
      comment.classList.remove('quote-box--unread');
    });
  }

  demoteComment(commentId) {
    this._findCommentElements(commentId).forEach(comment => {
      comment.classList.remove('quote-box--important');
      triggerEvent(comment, 'comment:demoted');
    });
  }

  demote(commentId) {
    return new Comment(commentId).demote();
  }

  elevateComment(commentId) {
    this._findCommentElements(commentId).forEach(comment => {
      comment.classList.add('quote-box--important');
    });
  }

  elevate(commentId) {
    return new Comment(commentId).elevate();
  }

  _handleDeleteClick(event) {
    // eslint-disable-next-line no-alert
    if(!confirm(this.confirmRemoveCommentMessage)) return;
    let commentId = parseInt(event.delegateTarget.dataset.commentDelete);
    this.delete(commentId).then(res => res.status === 'OK' && this.deleteComment(commentId));
  }

  delete(commentId) {
    return new Comment(commentId).delete();
  }

  deleteComment(commentId) {
    this._findCommentElements(commentId).forEach(comment => {
      comment.parentElement.removeChild(comment);
      triggerEvent(comment, 'comment:deleted');
    });
  }
}

module.exports = CommentsHelper;
